import React, {useState, useEffect} from "react";
import ResetPopupImg from "../Assets/ResetPopup.png";

const ScheduleConfirmationPopup = ({setShowScheduleConfirmationPopup, selectedInstructorCardType, SchduleConfirmationClick,
     setFinalClassesSchedule, setAddClassEvents, addClassEvents, instructorSelectedType, finalClassesSchedule,
     activeType, setFinalDrivingClassesSchedule, setFinalInClassClassesSchedule, setFinalOnlineClassesSchedule }) => {
  const Border = "border-[#E2E2E2] border-[1px] border-solid";

  const closePopup = () =>{
      console.log("Close icon clicked");
      setShowScheduleConfirmationPopup(false);
  }

//   const handleConfirm = () => {
//     SchduleConfirmationClick(selectedInstructorCardType); // ✅ Call with type
//     setShowScheduleConfirmationPopup(false);              // ✅ Close popup after confirming
//   };

  const handleConfirm = () => {
    console.log("addClassEvents in handleConfirm:",addClassEvents)

    const updatedFinal = [...finalClassesSchedule, ...addClassEvents];
    setFinalClassesSchedule(updatedFinal);

    // Append new class events to the existing final schedule
    // setFinalClassesSchedule(prev => [...prev, ...addClassEvents]);
    console.log("finalClassesSchedule in handleConfirm:",finalClassesSchedule)

      // Update based on activeType
      if (activeType === "Driving") {
        setFinalDrivingClassesSchedule(addClassEvents);
      } else if (activeType === "InClass") {
        setFinalInClassClassesSchedule(addClassEvents);
      } else if (activeType === "Online") {
        setFinalOnlineClassesSchedule(addClassEvents);
      } else {
        console.warn("Unknown activeType:", activeType);
      }      

    // Clear the temporary class events
    setAddClassEvents([]);
  
    // Call confirmation handler and close popup
    SchduleConfirmationClick(selectedInstructorCardType, updatedFinal);
    setShowScheduleConfirmationPopup(false);
  }; 
    
    return (
      <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg w-[340px] lg:w-[370px]">
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={closePopup}
              />
            </div>

            <div  className="mt-[-120px] flex w-full justify-center items-center">
              <img
                src={ResetPopupImg}
                alt="img"
              />
            </div>

          <h2
            className=" mb-2 text-center text-[16px]"
          >
            Schedule Confirmation
          </h2>
          <p className="text-center text-[14px]">Is this the final schedule for {instructorSelectedType} hours? You’ll still be able to edit it later.</p>
          
          <div className="w-full flex flex-col ustify-center items-center gap-[15px] mt-[15px]">
            <button
                className="px-[15px] py-[7px] w-[90%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={handleConfirm} // ✅ Call confirm handler
                style={{border:"2px solid #A1A3EF"}}>
                Confirm
            </button>

            <p className="text-[14px] text-center cursor-pointer" onClick={closePopup}>Edit</p>
          </div>
        </div>
      </div>
    );
  };

export default ScheduleConfirmationPopup;
